export default "<p>register works!</p>\r\n";